module.exports = __webpack_public_path__ + "static/img/session1.0707a9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/session1.jpg
// module id = RF8a
// module chunks = 0